import * as types from './types'

const state = {
  pagination: {
    itemsPerPage: 10,
  },
  search: null,
};

const getters = {
  pagination: (state) => state.pagination,
  search: (state) => state.search,
};

const actions = {
  update({ commit }, pagination) {
    commit(types.UPDATE, pagination);
  },
  reset({ commit }, pagination = { itemsPerPage: 10 }) {
    commit(types.UPDATE, Object.assign({}, pagination, {
      page: 1,
      sortBy: [],
    }));
    commit(types.SEARCH, null);
  },
  search({ commit }, search) {
    commit(types.SEARCH, search);
  },
};

const mutations = {
  [types.UPDATE](state, pagination) {
    state.pagination = pagination;
  },
  [types.SEARCH](state, search) {
    state.search = search;
  },
  reset(state, pagination = { itemsPerPage: 10 }) {
    state.pagination = Object.assign({}, pagination, {
      page: 1,
      sortBy: [],
    });

    state.search = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
